import { Component, OnInit } from '@angular/core';
import { HttpserviceService } from '../../service/http.service.service';
import { Router } from '@angular/router';
import { UtilsService } from '../../service/utils.service';
import { GlobalConfig } from '../../entities/global-config';
import { BsModalRef } from 'ngx-bootstrap';
import { Subject } from 'rxjs/Subject';
import { BsModalService } from 'ngx-bootstrap/modal';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { DaterangepickerConfig } from 'ng2-daterangepicker';
import { DatePipe } from '@angular/common';

import { ConformMessageComponent } from '../../conform-message/conform-message/conform-message.component';
declare var moment: any;
@Component({
  selector: 'app-visitors',
  templateUrl: './visitors.component.html',
  styleUrls: ['./visitors.component.css']
})
export class VisitorsComponent implements OnInit {

  isList: Boolean = true;
  public mainInput = {
    start: moment().subtract(1, 'month'),
    end: moment().subtract(0, 'month')
  };

  public singlePicker = {
    minDate: moment().subtract(120, 'month'),
    maxDate: moment().add(12, 'month'),
    daterangepicker: true,
    showDropdowns: true,
    opens: 'left',
  };

  public singleDate: any;
  public eventLog = '';

  constructor(
    private servicesComponent: HttpserviceService,
    private router: Router,
    private utilsService: UtilsService,
    private config: GlobalConfig,
    private toastr: ToastsManager,
    private modalService: BsModalService,
    private daterangepickerOptions: DaterangepickerConfig
  ) 
    {
      this.daterangepickerOptions.settings = {
        locale: { format: 'YYYY-MM-DD' },
        alwaysShowCalendars: false,
        ranges: {
          'Last Month': [moment().subtract(1, 'month'), moment()],
          'Last 3 Months': [moment().subtract(4, 'month'), moment()],
          'Last 6 Months': [moment().subtract(6, 'month'), moment()],
          'Last 12 Months': [moment().subtract(12, 'month'), moment()],
        }
      };
      this.singleDate = Date.now();
}
  bsModalRef: BsModalRef;
  totalItems: any = Number;
  visitors: any[] = [];
  topIPVisitors: any[] = [];
  topEmailVisitors: any[] = [];
  topMobileVisitors: any[] = [];
  usersIds: any[] = [];
  checkAll: Boolean = false;
  listDates: any = [];
  chartDates: any = [];
  chartDatesCount: any = [];
  page: any = { pageNumber: 1, pageSize: 10, startDate: this.mainInput.start, endDate: this.mainInput.end };
  ngOnInit() {
    this.getVisitorsAsync();
  }

  getVisitorsAsync() {
    this.servicesComponent.getVisitorsAsync(this.page)
      .then((response: any) => {
        if (response.success && response.receiveObj.totalResults > 0) {
          this.visitors = response.receiveObj.visitorLogDetail;//.result.data;
          this.totalItems = response.receiveObj.totalResults;
          this.isList = true;
        } else {
          this.visitors = [];//.result.data;
          this.totalItems = 0;
          this.isList = false;
        }
        this.topIPVisitors = response.receiveObj.topIPVisitor;
        this.topEmailVisitors = response.receiveObj.topEmailVisitor;
        this.topMobileVisitors = response.receiveObj.topMobileVisitor;
      })
      .catch(error => {
        console.log(error);
        this.toastr.error('Some error occured, Please contact admin.', 'Error!');
      });
  }

  pageChanged(event: any): void {
    this.page.pageNumber = event.page;
    this.page.pageSize = event.itemsPerPage;
    this.listDates = [];
    this.chartDates = [];
    this.chartDatesCount = [];
    this.getVisitorsAsync();
  }
  private selectedDate(value: any, dateInput: any) {
    dateInput.start = value.start;
    dateInput.end = value.end;
    var datePipe = new DatePipe('en-US');
    this.page.startDate = datePipe.transform(dateInput.start, 'yyyy-MM-dd');
    this.page.endDate = datePipe.transform(dateInput.end, 'yyyy-MM-dd');
    this.getVisitorsAsync();
  }

  private singleSelect(value: any) {
    this.singleDate = value.start;
  }

  private applyDate(value: any, dateInput: any) {

    dateInput.start = value.start;
    dateInput.end = value.end;
  }

  public calendarEventsHandler(e: any) {
    this.eventLog += '\nEvent Fired: ' + e.event.type;
  }

  getDates(start, end) {
    var datesArray = [];
    var newStart = new Date(start);
    var newEnd = new Date(end);
    start = newStart;
    end = newEnd;
    var startDate = new Date(start);
    while (startDate <= end) {
      var m = (startDate.getMonth() + 1);
      var d = startDate.getDate();
      var da = d > 9 ? d : '0' + d.toString();
      var mo = m > 9 ? m : '0' + m.toString();
      var newDate = da + '-' + mo + '-' + startDate.getFullYear();
      datesArray.push(newDate);
      startDate.setDate(startDate.getDate() + 1);
    }
    return datesArray;
  }

  selectAllCheckBox() {
    this.usersIds = [];
    const userIdsValue = [];
    if (!this.checkAll) {
      this.visitors.forEach(function (value) {
        value.isDisable = true;
      });
    } else {
      this.usersIds = [];
      this.visitors.forEach(function (value) {
        value.isDisable = false;
      });
    }
  }

  result() {
    this.servicesComponent.enableDisableUser(this.usersIds)
      .then((response: any) => {
        if (response.success === true) {
          this.page.pageNumber = 1;
          this.getVisitorsAsync();
          this.toastr.success('visitors enable / disable successfully.', 'Success!');
        } 
      })
      .catch(error => {
        console.log(error);
        this.toastr.error('Some error occured, Please contact admin.', 'Error!');
      });
  }
  clearData() {
    this.page.searchKeyword = "";
    this.page.pageNumber = 1;
    this.page.withEmail = false;
    this.page.withMobile = false;
    this.page.
    this.getVisitorsAsync();
  }
}






// WEBPACK FOOTER //
// D:/Projects/Web/Dubai/code/kapil/DubairentV3/cpapi/CPDubairentApp/CPDubairentApp/src/app/visitors/visitors/visitors.component.ts